module.exports = __webpack_public_path__ + "img/horizontal_3_2_6000.bfce62f9.png";